// pages/FormViewerPage/services/formViewerService/validateMyAddress.ts — validasi alamat MY (split dari validation.ts)
import type { Form } from '../../../../types';
import type { AddressData } from '../../../../components/AddressInput';

// Form MY: Negeri + Bandar + Poskod (5 digit, wajib milik Bandar terpilih — dicegah di dropdown).
// Return null bila bukan MY (caller lanjut jalur ID).
export function validateMyAddress(
    form: Form | null,
    customerData: { name: string; whatsapp: string; email: string },
    addressData: AddressData,
): Record<string, string> | null {
    if ((form as any)?.addressCountry !== 'MY') return null;
    const errors: Record<string, string> = {};
    const customerFields: Record<string, any> = form?.customerFields || {};
    if (!addressData.province) errors.province = 'Sila pilih negeri';
    if (!addressData.city) errors.city = 'Sila pilih bandar';
    const pc = String((addressData as any).postalCode || '').trim();
    if (!pc) errors.postalCode = 'Sila pilih poskod';
    else if (!/^\d{5}$/.test(pc)) errors.postalCode = 'Poskod tidak sah (5 digit)';
    const addr = (addressData.detailAddress || addressData.fullAddress || '').trim();
    if (customerFields.address?.visible && customerFields.address?.required && addr.length < 8) {
        errors.address = 'Sila tulis alamat penuh (jalan, taman, no. rumah)';
    }
    return errors;
}
